// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"80":"6bb8cdc8","300":"1e53cfb9","608":"c045f619","700":"877eb608","731":"c342c714","825":"7a855ad7"}[chunkId] + ".css";
};